import { Card } from '@/components/ui/card';
import { FoodSupplement } from '@repo/types/src/food-supplement';
import { DeleteFoodSupplement } from './DeleteFoodSupplement';
import { EditFoodSupplement } from './EditFoodSupplement';

type FoodSupplementCardProps = {
  item: FoodSupplement;
  refetch: () => void;
};

export const FoodSupplementCard = ({
  item,
  refetch,
}: FoodSupplementCardProps) => {
  return (
    <Card className="w-80 h-80 flex flex-col overflow-hidden">
      {item.image ? (
        <img
          src={item.image}
          alt={item.name}
          className="w-full h-40 shrink-0 object-cover"
        />
      ) : (
        <div className="w-full h-40 shrink-0 bg-zinc-100 dark:bg-zinc-800 flex items-center justify-center">
          <span className="text-zinc-400 dark:text-zinc-500 text-sm">
            Pas d&apos;image
          </span>
        </div>
      )}
      <div className="flex h-40 flex-col gap-0.5 p-2 overflow-hidden ">
        <div className="flex items-center gap-2 flex-wrap">
          <h3 className="font-semibold">{item.name}</h3>
          {item.fastActing && (
            <span className="text-xs bg-green-100 text-green-800 px-2 py-0.5 rounded-full">
              Action rapide
            </span>
          )}
        </div>
        {item.taste && (
          <p className="text-xs text-gray-500">Goût : {item.taste}</p>
        )}
        {item.dosagePerDay && (
          <p className="text-xs text-gray-500">
            Dosage : {item.dosagePerDay}/jour
          </p>
        )}
        {item.description && (
          <p className="text-xs text-gray-600 line-clamp-1">
            {item.description}
          </p>
        )}
        {item.link && (
          <a
            href={item.link}
            target="_blank"
            rel="noreferrer"
            className="text-xs text-blue-500 dark:text-blue-400 underline truncate"
          >
            {item.link}
          </a>
        )}
      </div>
      <div className="flex gap-2 px-2 pb-2 shrink-0">
        <EditFoodSupplement item={item} refetch={refetch} />
        <DeleteFoodSupplement item={item} refetch={refetch} />
      </div>
    </Card>
  );
};
